import React, { Component } from "react";
import Select from "react-select";
import { inject } from "mobx-react";
import withLocalization from "../../hoc/withLocalization";
import applicationRouter from "../../hoc/applicationRouter";
import moment from 'moment';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CreatableSelect from "react-select/creatable";

class GenericSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fromDate: null,
            toDate: null,
            selectedEntity: null
        };
    }

    onDateChange = (type, date) => {
        this.setState({ [type]: date }, () => {
            this.handleChanges();
        });
    };

    handleEntityChange = (entity) => {
        if (!entity) {
            this.setState({ selectedEntity: null }, () => { this.handleChanges(); });
            return;
        }

        if (entity.isCustom) {
            this.setState({ selectedEntity: entity }, () => { this.handleChanges(); });
        }
        else {
            this.setState({
                selectedEntity: {
                    value: entity.value,
                    label: entity.label,
                    dbId: entity.dbId,
                    code: entity.code,
                    description: entity.description,
                    isCustom: false
                }
            }, () => { this.handleChanges(); });
        }
    };

    handleManuallyTypeOption = (inputValue) => {
        const trimmedValue = inputValue.trim();
        const { entity } = this.props;
        const rules = this.getEntityRules(entity);
        const isCode = /^[\d-]+$/.test(trimmedValue);

        if ((isCode && !rules.allowCode) || (!isCode && !rules.allowDescription)) return;

        const newOption = {
            value: isCode ? trimmedValue : null,
            label: inputValue,
            description: isCode ? null : inputValue,
            code: isCode ? trimmedValue : null,
            isCustom: true,
            type: isCode ? 'code' : 'description'
        };

        this.setState({ selectedEntity: newOption }, () => { this.handleChanges(); });
    };

    getEntityRules = (entity) => {
        const rules = {
            projects: { allowCustom: true, allowCode: true, allowDescription: false, idField: 'dbId', codeField: 'code', descriptionField: 'description', fromField: 'createdAt_gte', toField: 'createdAt_lte' },
            tasks: { allowCustom: false, idField: 'activityDbId', fromField: 'createdAt_gte', toField: 'createdAt_lte' },
            employees: { allowCustom: true, allowCode: true, allowDescription: true, idField: 'dbId', codeField: 'code', descriptionField: 'description', fromField: 'dateTo_gte', toField: 'dateTo_lte' },
        };
        return rules[entity] || { allowCustom: false, idField: 'dbId', fromField: 'createdAt_gte', toField: 'createdAt_lte' };
    };


    handleChanges = () => {
        const { fromDate, toDate, selectedEntity } = this.state;
        const { entity } = this.props;
        const entityRules = this.getEntityRules(entity);
        const filters = {};

        if (fromDate) filters[entityRules.fromField] = entity === 'employees' ? fromDate.format('YYYY-MM-DD') : fromDate.format('YYYY-MM-DD[T]00:00:00');
        if (toDate) filters[entityRules.toField] = entity === 'employees' ? fromDate.format('YYYY-MM-DD') : toDate.format('YYYY-MM-DD[T]23:59:59');
        if (selectedEntity) {
            if (selectedEntity.isCustom) {
                if (selectedEntity.type === 'description') filters[entityRules.descriptionField] = selectedEntity.description;
                else if (selectedEntity.type === 'code') filters[entityRules.codeField] = selectedEntity.code;
            } else filters[entityRules.idField] = selectedEntity.value;
        }

        Object.keys(filters).forEach(key => {
            if (filters[key] === undefined) delete filters[key];
        });

        this.props.onChange && this.props.onChange(filters);
    };

    getOptions = () => {
        const { entity, commonStore } = this.props;
        const list = commonStore?.integrationMetaData?.[entity]?.data || [];

        return list.map(item => ({
            value: entity === 'tasks' ? item.activityDbId : item.dbId,
            label: `${item.code} - ${item.description}`,
            dbId: item.dbId,
            code: item.code,
            description: item.description,
            isCustom: false
        }));
    };

    render() {
        const { entity, t, fromDateTooltip, toDateTooltip, displayName, searchTooltip } = this.props;
        const { fromDate, toDate } = this.state;
        const entityRules = this.getEntityRules(entity);
        const SelectComponent = entityRules.allowCustom ? CreatableSelect : Select;

        return (
            <div className="row g-3 align-items-end mb-3">
                <div className="col-md-4">
                    <label className="form-label">{t('From date')}</label>
                    <div className="input-group">
                        <input
                            type="date"
                            value={fromDate ? fromDate.format('YYYY-MM-DD') : ''}
                            onChange={(e) => this.onDateChange('fromDate', e.target.value ? moment(e.target.value) : null)}
                            className="form-control"
                        />
                        <button
                            className="btn btn-outline-secondary"
                            type="button"
                            onClick={() => this.onDateChange('fromDate', null)}
                            disabled={!fromDate}
                            style={{ zIndex: 2 }}
                        >
                            ×
                        </button>
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip-from-date">{t(fromDateTooltip)}</Tooltip>}
                        >
                            <span className="input-group-text bg-transparent border-0">
                                <i className="fas fa-info-circle text-muted"></i>
                            </span>
                        </OverlayTrigger>
                    </div>
                </div>
                <div className="col-md-4">
                    <label className="form-label">{t('To date')}</label>
                    <div className="input-group">
                        <input
                            type="date"
                            value={toDate ? toDate.format('YYYY-MM-DD') : ''}
                            onChange={(e) => this.onDateChange('toDate', e.target.value ? moment(e.target.value) : null)}
                            className="form-control"
                        />
                        <button
                            className="btn btn-outline-secondary"
                            type="button"
                            onClick={() => this.onDateChange('toDate', null)}
                            disabled={!toDate}
                        >
                            ×
                        </button>
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip-to-date">{t(toDateTooltip)}</Tooltip>}
                        >
                            <span className="input-group-text bg-transparent border-0">
                                <i className="fas fa-info-circle text-muted"></i>
                            </span>
                        </OverlayTrigger>
                    </div>
                </div>
                <div className="col-md-4">
                    <label className="form-label">{t(displayName)}</label>
                    <div className="d-flex align-items-center">
                        <div className="flex-grow-1 me-2" style={{ minWidth: 0 }}>
                            <SelectComponent
                                options={this.getOptions()}
                                value={this.state.selectedEntity}
                                onChange={this.handleEntityChange}
                                isClearable
                                isSearchable
                                onCreateOption={entityRules.allowCustom ? this.handleManuallyTypeOption : undefined}
                                formatCreateLabel={(inputValue) => `Search "${inputValue}"`}
                                isValidNewOption={(inputValue, selectValue, selectOptions) => {
                                    if (!inputValue.trim()) return false;
                                    const match = selectOptions.some(option =>
                                        option.label === inputValue ||
                                        option.value === inputValue ||
                                        option.code === inputValue ||
                                        option.description === inputValue
                                    );

                                    return !match;
                                }}
                                styles={{
                                    menu: (provided) => ({
                                        ...provided,
                                        width: '100%',
                                        zIndex: 1000,
                                    }),
                                }}
                            />
                        </div>
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip id="tooltip-entity-selector">
                                    {searchTooltip ? t(searchTooltip) : t('You can search or filter') + ' ' + t(displayName)}
                                </Tooltip>
                            }
                        >
                            <span className="input-group-text bg-transparent border-0 p-0">
                                <i className="fas fa-info-circle text-muted"></i>
                            </span>
                        </OverlayTrigger>
                    </div>
                </div>
            </div>
        );
    }
}

export default applicationRouter(withLocalization(inject('commonStore')(GenericSearch)));
